<template>
              
			<div class="uom_master_add_single col-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12">
			   
				<div class="module-wrapper">
				   
					<section class="module module-has-footer module-projects-overview">
					
						<div class="module-inner">
							<div class="module-heading">
								<h3 class="module-title">Add New UOM Code : <span class="pro-label label label-info btn-sm">{{uom_data.uom_code}}</span></h3>
								<ul class="actions list-inline">
									<li><a class="collapse-module" data-toggle="collapse" href="#content-overview" aria-expanded="false" aria-controls="content-overview"><span aria-hidden="true" class="icon arrow_carrot-up"></span></a></li>
								</ul>
							</div>
							
							<div class="module-content collapse in" id="content-overview">
								<div class="module-content-inner">

                                  <div class="row">
									<div id="uom_code" class="form-group col-md-6">
										<label>UOM Code</label>
										<input type="text" class="form-control" placeholder="Enter an UOM code" v-model="uom_data.uom_code" @blur="check_uom_exists">
									</div>
																	
 									<div class="col-md-6">
										<label>UOM Desc</label>
										<input type="text" class="form-control" placeholder="Enter an UOM Desc" v-model="uom_data.uom_desc">
									</div>                                  
									
                                     
                                
                                </div>                                  
                                 
                                 <button type="button" id="add_save_button" class="data_save btn btn-primary" @click="add_uom_data">Save</button>                                 
                                 <button type="button" class="data_cancel btn btn-warning" @click="show_uom_table">Cancel</button>                                 
                                                                                                                                    
							
				              
				              </div>
								
							</div>
							
						</div>
						
				        <div class="module-footer text-center">
                            <p class="meta"><span><li>Created By: {{ uom_data.cr_user_code }} at : {{uom_data.cr_datetime}}</li></span>&nbsp;&nbsp;<span><li>Modified By: {{ uom_data.md_user_code }} at : {{ uom_data.md_datetime }} </li></span></p>
						</div>
						
						 <spinner :visible="ajax_loader"></spinner>
					</section>
					
				</div>		
            </div>	
            
<!--row -->	 
       
</template>


<script>
import modalnotify from '@/components/supportcomp/modalnotify.vue' 
import spinner from '@/components/supportcomp/spinner.vue' 

export default {
  name: 'uom_master_add_single',    
  data () {
    return {    
      msg: '',
      security_ojb : '',
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false,
      uom_data : { uom_code: "" , 
                   uom_desc : "",
                   cr_user_code : "",
                   cr_datetime : "",
                   md_user_code : "",
                   md_datetime : "" 
                 },
     dirty_check : {}    
    }
  },
  components: {
      modalnotify,
      spinner
   },
methods: {
    
     show_uom_table : function () {
          
           var x = this;
         
           x.uom_data = { uom_code: "" , 
                      uom_desc : "",
                      cr_user_code : "",
                      cr_datetime : "",
                      md_user_code : "",
                      md_datetime : "" 
           };          
         
          $(".wtips_uom_table_view").show(600);
          $(".uom_master_add_single").hide(600);
          
     },
    
    add_uom_data : function () {
 
                             var x = this;
        
                             if (x.dirty_check.uom_code)
                                 { 
                                     
                                     notify_uom_check();
                                     return;
                                 
                                 }
        
        
                             var object_data = {"data_api_key":'add_single_uom_master_data', "uom_data" : x.uom_data , "base_module":"uom_master"};
        
                             x.uom_data = { uom_code: "" , 
                                         uom_desc : "",
                                         cr_user_code : "",
                                         cr_datetime : "",
                                         md_user_code : "",
                                         md_datetime : "" 
                                       };       
                              
                             
                             x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                     
                                      x.ajax_loader=false;
                                 
                                      
                                      //MstObj.uom_data = data.data;
                                    if (data.data=="ERR"){

                                                      notify('Error occured on saving UOM data : '+data.err, 'warn',true,false,'topLeft');
                                                      $(".wtips_uom_table_view").show(600);
                                                      $(".uom_master_add_single").hide(600);                                        
                                        
                                    }
                                  
                                    if (data.data=="SUCCESS")
                                        {
                                            
                                                      notify('UOM data saved successfully', 'info',true,false,'topLeft');
                                                      //setTimeout(function(){ location.reload(); }, 2000);
                                                      $(".wtips_uom_table_view").show(600);
                                                      $(".uom_master_add_single").hide(600);
                                                      
                                                      x.$emit("refresh");
                                            
                                                      
                                                       
                                            
                                        }
                                  /*
                                     $.each( data.data, function( i, val ) {
                                                   
                                                    
                                             //MstObj.uom_data = val;
                                               
                                     });                              */
                                 
                                 

                             })
                              .fail(function(){
                                 x.ajax_loader=false; 
                             }); //                      
            
    },
    

    
    check_uom_exists :  _.debounce(function (event) {
            
        
                             var x = this;

                              if (x.uom_data.uom_code != ""){
        
                             var object_data = {"data_api_key":'view_single_uom_master_data', "uom_code" : x.uom_data.uom_code , "base_module":"uom_master"};
                            
                             //x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                     
                                      //x.ajax_loader=false;
                                 
                                      
                                      //MstObj.uom_data = data.data;
                                    if (data=="No_records"){
                                        x.dirty_check.uom_code = false; 
                                        $("#uom_code").removeClass("has-error");
                                    }
                                else{
                                    
                                     x.dirty_check.uom_code == true;
                                     notify_uom_check();
                                    
                                }                              
                             })
                              .fail(function(){
                                 //x.ajax_loader=false; 
                             }); //              
        
                              
                            } //
                           else
                               {
                                   
                                     x.dirty_check.uom_code = true;
                                     notify('UOM Code is empty', 'warn',true,false,'topLeft');
                                     if (!$("#uom_code").hasClass('has-error')){
                                       $("#uom_code").addClass("has-error"); 
                                     }                                   
                                   
                               }
 
                            
                        
                    },800)

        
    
}, //end of Methods //
    
    
    
watch : {
    
    

    
},    
    
mounted : function () {
       var x = this;
       //setTimeout(function(){ x.setSecurity(); }, 200);
   } //end of mounted

} //end export
 

function notify_uom_check(){
    
                                     notify('An already existing UOM code found in db, Please check and change to a different code', 'warn',true,false,'topLeft');
                    		             
                                    
                                     $("#uom_code").notify('UOM Code already exists!', {
                    		             	style: 'appkit',
                    		             	className: 'warn',
                    		             	hideAnimation: 'fadeOut',
                    		             	showAnimation: 'fadeIn',
                    		             	showDuration: 200,
                    		             	elementPosition: 'top center',
                                            autoHide: true,
                                            autoHideDelay: 3000                         
                    		             });
                                    
                                   if (!$("#uom_code").hasClass('has-error')){
                                       $("#uom_code").addClass("has-error"); 
                                   }    
    
}


</script>
<style>
.data_save {

  margin-right : 10px;
    }
.data_cancel {

  margin-left: 10px;

}
</style>


// WEBPACK FOOTER //
// src/components/app-pages/uom-master/uom-master-add-single.vue